/* src/app/_shared/components/footer/footer.component.scss */
:host {
  --padding: var(--space-top) var(--space-right) calc(env(safe-area-inset-bottom, 0) + var(--space-bottom)) var(--space-left);
  --border-color: var(--ion-color-light);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: block;
  width: 100%;
  height: auto;
  padding: 0;
  border-top: none;
  transform: translateZ(0);
}
:host.hide footer {
  transform: translateY(100%);
}
footer {
  padding: var(--padding);
  border-top: 1px solid var(--border-color);
  background-color: #FFFFFF;
  transition: transform 0.2s;
}
/*# sourceMappingURL=footer.component.css.map */
